import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { path } from 'ramda';

import Link from 'react-router/lib/Link';
import ShopType from './shopType';
import Date from '../../../common/date';
import Icon, { GLYPHS } from '../../../common/icon';
import ImpersonateUser from '../../shared/ImpersonateUser';

const getUserId = path(['users', '0', 'id']);

class ShopsTable extends Component {
  render() {
    const { shops } = this.props;

    function sortShops(a, b) {
      a = a.toLowerCase(); // eslint-disable-line no-param-reassign
      b = b.toLowerCase(); // eslint-disable-line no-param-reassign
      if (a === b) return 0;
      if (a > b) return 1;
      return -1;
    }

    return (
      <div>
        <div
          className="c-label c-label--strong u-fontsize-normal u-text-right"
          style={{ marginTop: -45, marginBottom: 45 }}
        >
          Total shops <span>({shops && shops.length})</span>
        </div>
        <ReactTable
          className="c-table-new c-no-hover u-mt"
          data={shops}
          minRows={0}
          showPagination={false}
          defaultPageSize={10000}
          resizable={false}
          columns={[{
            Header: 'Name',
            accessor: 'name',
            minWidth: 240,
            sortMethod: sortShops,
            Cell: props => <div>{props.value}</div>,
          }, {
            Header: <span>Bank <br />account</span>,
            accessor: 'bankAccountId',
            width: 80,
            Cell: row => (row.value ? <Icon glyph={GLYPHS.bank} size="small" /> : null),
          },
          {
            Header: 'Email',
            accessor: 'email',
            minWidth: 270,
          }, {
            Header: 'City',
            accessor: 'city',
          }, {
            Header: 'Country',
            accessor: 'country',
          }, {
            Header: 'Shop type',
            accessor: 'kind',
            Cell: row => <ShopType type={row.value} />,
          }, {
            Header: 'Barbers',
            accessor: 'barberCount',
          }, {
            Header: 'Date added',
            accessor: 'createdAt',
            Cell: row => <Date>{row.value}</Date>,
          }, {
            Header: 'Actions',
            id: 'actions',
            accessor: shop => shop,
            maxWidth: 80,
            Cell: row => (
              <span>
                <Link className="u-co-primary u-type--bold" to={`/admin/shops/${row.value.id}`}>Edit</Link>
                <br />
                <ImpersonateUser id={getUserId(row.value)} />
              </span>
            ),
          }]}
          defaultSorted={[
            {
              id: 'name',
              asc: true,
            },
          ]}
        />
      </div>
    );
  }
}

ShopsTable.propTypes = {
  shops: PropTypes.array,
};

ShopsTable.defaultProps = {
  shops: [],
};

export default ShopsTable;
